"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.capitalizeFirstLetter = void 0;
const capitalizeFirstLetter = (str) => {
    if (typeof str === 'string' && str.length) {
        const capitalizedFirstLetter = str.charAt(0).toUpperCase();
        const rest = str.slice(1);
        return capitalizedFirstLetter + rest;
    }
    return str;
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
//# sourceMappingURL=capitalizeFirstLetter.js.map